<template>
  <main class="about">
    <section class="icik-intro">
      <div class="icik-intro__inner">
        <!-- 왼쪽: 이미지 -->
        <div class="icik-intro__image">
          <img src="@/assets/HeaderICIK.png" alt="ICIK 로고" />
        </div>

        <!-- 오른쪽: 텍스트 -->
        <div class="icik-intro__text">
          <h2 class="icik-intro__title">
            한국내부통제협회 (Internal Control Institute Korea, ICI KOREA)
          </h2>
          <p>
            한국내부통제협회는 국제내부통제협회 한국지부(ICI Korea)로서,
            내부통제, 기업지배구조, 리스크 관리, 준법감시 및 감사 분야의 전문성 강화를 위해 설립된 국내 대표 내부통제 전문단체입니다.
            내부통제 평가 강화와 리스크 대응력 제고의 중요성이 커지는 환경 속에서, 협회는 내부통제 체계 구축, 중장기 전략 수립, 전사 리스크 관리,
            전문가 교육 및 국제 전문자격 과정(CICS, CICP) 등을 통해 조직의 투명경영과 리스크 관리 수준 향상을 지원하고 있습니다.
            아울러 공공기관과 민간기업의 지속가능한 성장과 투명한 경영문화 확산을 목표로,
            검증된 방법론과 풍부한 경험을 바탕으로 회원과 함께 성장하는 신뢰받는 전문 파트너로 자리매김하고 있습니다.
          </p>
        </div>
      </div>
    </section>
    <!-- Vision -->
    <section class="section vision" aria-labelledby="vision-title">
      <div class="section__inner">
        <h2 class="visionh2" id="vision-title">
          Vision & Values

        </h2>
        <!-- <p class="vision__text">
          공공기관, 민간기업 등 조직 모두가 인식하고 신뢰하는 전문적이고 다양성 있는 내부통제 커뮤니티의 핵심 축이 되는 것을 목표로 합니다.<br />
          내부통제와 거버넌스 분야의 지식, 실무, 발전을 선도하는 신뢰받는 플랫폼이 되고자 합니다.

        </p> -->
      </div>
      <!-- Values -->
      <div class="section values">
        <div class="section__inner2">
          <!-- <h2 class="section__title">Values</h2> -->

          <ul class="values__grid">
            <li class="card">
              <h3>정직성과 투명성 <br />(Integrity)</h3>
              <br />
              <!-- icon -->
              <div class="card__icon">
                <i class="fa-solid fa-shield-halved"></i>
              </div>
              <p>
                모든 활동에서 윤리적 기준을<br />
                최우선으로 삼으며, 투명하고 책임<br />
                있는 조직문화를 지향합니다.
              </p>
            </li>

            <li class="card">
              <h3>전문성의 추구<br /> (Professional Excellence)</h3>
              <br />
              <!-- icon -->
              <div class="card__icon" aria-hidden="true">
                <i class="fa-solid fa-graduation-cap"></i>
              </div>
              <p>
                세계적 수준의 교육과 연구를 통해<br />
                내부통제 전문가의 지식과 역량 강화를<br />
                지원합니다.
              </p>
            </li>

            <li class="card">
              <h3>조직의 실질적인 기여<br /> (Practical Impact)</h3>
              <br />
              <!-- icon -->
              <div class="card__icon" aria-hidden="true">
                <i class="fa-solid fa-chart-line"></i>
              </div>
              <p>
                조직의 거버넌스와 리스크 관리<br />
                개선에 실질적 기여를 할 수 있는<br />
                적용 가능한 통찰을 제공합니다.
              </p>
            </li>

            <li class="card">
              <h3>협력과 파트너십<br /> (Collaboration)</h3>
              <br />
              <!-- icon -->
              <div class="card__icon" aria-hidden="true">
                <i class="fa-solid fa-handshake"></i>
              </div>
              <p>
                민간, 공공, 비영리 부문과의<br />
                적극적인 소통과 협력을 통해<br />
                공동의 가치를 창출합니다.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="ici-about">
      <div class="ici-about__inner">
        <!-- 왼쪽: 이미지 -->
        <div class="ici-about__image">
          <img src="@/assets/main-ici.png" alt="ICI 로고" />
        </div>

        <!-- 오른쪽: 텍스트 -->
        <div class="ici-about__text">
          <h2 class="ici-about__title">
            국제내부통제협회 (Internal Control Institute, ICI)
          </h2>

          <p>
            국제내부통제협회(Internal Control Institute, ICI)는 전 세계에서 유일하게 내부통제와 기업지배구조 분야에 전념하는 국제 전문기관으로,
            조직이 효과적인 내부통제 체계를 구축할 수 있도록 방법론, 평가도구, 교육, 인증 프로그램을 제공합니다.
            ICI는 내부통제의 글로벌 표준을 제시하며, 정량적 리스크 평가와 전문 자격 인증(CICS, CICP)을 통해 개인의 역량과
            조직의 투명경영 수준을 함께 강화합니다. 또한 회원 프로그램을 통해 최신 내부통제 동향과 모범사례를 공유하며,
            전 세계 내부통제 전문가 네트워크의 중심 역할을 수행하고 있습니다.
          </p>

          <div class="ici-about__info">
            <p><strong>ICI 홈페이지</strong><br /><a href="https://www.theinternalcontrolinstitute.com/">www.theinternalcontrolinstitute.com</a></p>
            <p>
              <strong>ICI Mailing Address</strong><br />
              13575 58th Street North #282 Clearwater, FL 33760-3721, USA
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="kakaomap">
      <div>
        <h1>한국내부통제협회 위치</h1>
        <KakaoMap />

        <!-- 연락/주소 카드 -->
        <div class="map-contact">
          <div class="contact-item">
            <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
            <div class="contact-text">
              <span class="label">주소</span>
              <address>
                08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬)
              </address>
            </div>
          </div>

          <div class="contact-item">
            <i class="fas fa-phone" aria-hidden="true"></i>
            <div class="contact-text">
              <span class="label">전화번호</span>
              <a class="tel" href="tel:07044897447" aria-label="전화걸기 070-4489-7447">
                070-4489-7447
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import KakaoMap from '@/components/kakaomap/KakaoMap.vue';

</script>

<style scoped src="./style.css"></style>
